import * as yup from "yup";
import { FilterDefinition } from "components/Shared/FilterEditor/utils";
import {
  getDateTimeFilterDefinition,
  getSearchFilterDefinition,
  getSelectFilterDefinition,
  getStringFilterDefinition,
  makeCombinedSearchFilter,
} from "components/Shared/FilterEditor/standardFilters";
import { CommentFilter } from "__generated__/gql/graphql";
import { getFilterDefinitions as getBrandRetailerFilterDefinitions } from "components/Retailers/Index/filterDefinitions";
import createNestedFilterDefinitions from "components/Shared/FilterEditor/createNestedFilterDefinitions";
import { UserForBrandSelect } from "components/Shared/Select/UserSelect";
import { makeEnsureType } from "utils/typescriptUtilis";

const filterObj = makeEnsureType<CommentFilter>();

const brandRetailerFilters = createNestedFilterDefinitions(
  "brandRetailer",
  getBrandRetailerFilterDefinitions({ isRetailerTypeHidden: false }),
  { groupLabel: "Brand Retailer" },
);

const brandRetailerCommentFilters = createNestedFilterDefinitions(
  "brandRetailerComment",
  brandRetailerFilters,
);

export const baseCommentFilterDefinitions: FilterDefinition[] = [
  getDateTimeFilterDefinition({
    id: "createdAt",
    label: "Posted",
    defaultVariant: "greaterThan",
  }),
  getStringFilterDefinition({ id: "body", label: "Comment" }),
];

const filterDefinitions: FilterDefinition[] = [
  getSearchFilterDefinition({
    getResult: makeCombinedSearchFilter<CommentFilter>(
      [brandRetailerCommentFilters],
      (search) => ({ body: { includesInsensitive: search } }),
    ),
  }),
  ...baseCommentFilterDefinitions,
  getSelectFilterDefinition({
    id: "user",
    label: "Author",
    getSelectResult: (value, { filterVariantDefinition: { id: variantId } }) =>
      filterObj({ userId: { [variantId]: value } }),
    selectSchema: yup.string().uuid(),
    renderSelectInput: ({ field }, { isMulti }) => (
      <UserForBrandSelect
        {...field}
        isMulti={isMulti}
        menuPortalTarget={document.body}
      />
    ),
  }),
  ...brandRetailerCommentFilters,
];

export default filterDefinitions;
